export type NodeEnv = NodeJS.Process["env"]["NODE_ENV"];

//

function createConfig<Config extends Record<string, unknown>, DevConfig = Partial<Config>>(
  config: Config,
  devConfig: DevConfig = {} as DevConfig,
): Config & { nodeEnv: NodeEnv } {
  type FullConfig = Config & { nodeEnv: NodeEnv };

  const nodeEnv = process.env.NODE_ENV;
  const fullConfig: FullConfig = { nodeEnv, ...config };

  if (nodeEnv === "development") Object.assign(fullConfig, devConfig);

  return fullConfig;
}

//

export default createConfig;
